import { Injectable } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import { Nexus } from '@tomandco/nexus-api-types';
import { ProductConfiguration } from '../../product-configuration';
import { OptionArea } from './option/option-area';
import { OptionCheckbox } from './option/option-checkbox';
import { OptionDropdown } from './option/option-dropdown';
import { OptionField } from './option/option-field';
import { OptionMultiple } from './option/option-multiple';
import { OptionRadio } from './option/option-radio';

const instances = {
    area: OptionArea,
    checkbox: OptionCheckbox,
    drop_down: OptionDropdown,
    field: OptionField,
    radio: OptionRadio,
    multiple: OptionMultiple
};

export type TCustomOption = OptionField | OptionArea | OptionDropdown | OptionCheckbox | OptionMultiple | OptionRadio;

@Injectable()
export class ProductConfigurationCustomOptionsService {
    /**
     * Prepeares custom options models set
     */
    getOptions(product: Product<IProductDataV3>, configuration: ProductConfiguration): TCustomOption[] | undefined {
        return product.data?.options?.custom?.map(data => {
            const instance = instances[data.type];
            if (!instance) {
                throw new Error(`Unknown custom option type: ${data.type}`);
            }
            return new instance(configuration, data);
        });
    }

    /**
     * Converts options selection to buy request
     */
    getRequestOptions(options: TCustomOption[] | undefined): Nexus.Lib.Basket.BuyRequest['options'] | undefined {
        if (options) {
            const request: Nexus.Lib.Basket.BuyRequest['options'] = {};
            options
                .map(option => option.toRequest())
                .forEach(i => {
                    if (i) {
                        request[i.key] = i.value;
                    }
                });
            return request;
        }
        return undefined;
    }

    validate(options: TCustomOption[] | undefined): NProductConfiguration.Error.Entry[] | undefined {
        return options?.map(option => option.validate()).filter(i => !!i) as NProductConfiguration.Error.Entry[];
    }
}
